import React from "react";

type ButtonProps = {
    children: React.ReactNode;
    type?: "button" | "submit" | "reset";
    disabled?: boolean;
    className?: string;
    onClick?: () => void;
};

const Button = ({
    children,
    type = "button",
    disabled = false,
    className = "",
    onClick,
}: ButtonProps) => {
    return (
        <button
            type={type}
            disabled={disabled}
            onClick={onClick}
            className={className}
        >
            {children}
        </button>
    );
};

export default Button;
